import { useToast } from "@/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { CheckCircle, Info } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

export function Toaster({ duration = 3000 }: { duration?: number }) {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast
            className={cn(
              "relative rounded-lg border-none px-3 py-4 backdrop-blur-sm",
              props.variant === "destructive"
                ? "bg-[#F85F5F]/30"
                : "bg-[#45D3EC]/30"
            )}
            key={id}
            {...props}
            duration={duration}
          >
            <div className="flex items-center gap-[10px]">
              {props.variant === "destructive" ? (
                <Info size={30} color="white" />
              ) : (
                <CheckCircle size={30} color="white" />
              )}
              <div className="z-10 flex flex-col gap-[3px]">
                {title && (
                  <ToastTitle className="text-[15px] font-semibold leading-5 text-white">
                    {title}
                  </ToastTitle>
                )}
                {description && (
                  <ToastDescription className="text-[13px] font-medium leading-[17px] text-white">
                    {description}
                  </ToastDescription>
                )}
              </div>
            </div>
            {props.variant === "destructive" ? (
              <Info
                size={110}
                className="absolute -right-11 -top-14 text-black/5"
              />
            ) : (
              <CheckCircle
                size={110}
                className="absolute -right-11 -top-14 text-black/5"
              />
            )}
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
